export default __webpack_public_path__ + "static/media/electrolux.90bbda67.svg";